module.exports = __webpack_public_path__ + "static/img/yyzz.cad24d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/yyzz.png
// module id = n/et
// module chunks = 0